<template>
    <div v-loading="loading">
        <div style="text-align: right">
            <el-button
                    @click="submitFunc"
                    size="small"
                    type="primary">保存
            </el-button>
        </div>
        <el-transfer
                class="transfer"
                v-model="bankCodes"
                :data="bankList"
                :props="{key: 'bankCode',label: 'bankName'}"
                :titles="['银行列表','支持银行列表']"/>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        props: {
            info: Object
        },
        data() {
            return {
                loading: false,
                bankCodes: [],
            }
        },
        computed: {
            ...mapState('payChannel', ['bankList', 'channelBankList'])
        },
        methods: {
            ...mapActions('payChannel', ['getChannelBankList', 'updateChannelBank']),
            getList() {
                this.loading = true;
                this.getChannelBankList({
                    channelId: this.info.id
                }).then(res => {
                    this.loading = false;
                    this.bankCodes = res.data.map(item => item.bankCode)
                })
            },
            submitFunc() {
                this.updateChannelBank({
                    bankCodes: this.bankCodes,
                    channelId: this.info.id
                }).then(() => {
                    this.$message.success('保存成功');
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .transfer {
        display: flex;
        flex: 1;
        align-items: center;
        margin-top: 10px;
        :global(.el-transfer-panel) {
            flex: 1;
            height: 100%;
        }
        :global(.el-transfer-panel__body) {
            height: calc(100% - 40px);
        }
        :global(.el-transfer-panel__list){
            height: 100%;
            @extend %scrollbar;
        }
        :global(.el-transfer-panel__item) {
            width: 50%;
            height: auto;
            padding: 0 30px 10px;
            margin: 0;
            vertical-align: top;
            box-sizing: border-box;
            :global(.el-checkbox__input) {
                top: 2px;
            }

            :global(.el-checkbox__label) {
                line-height: 1.4;
                white-space: normal;
            }
        }

        :global(.el-button) {
            display: block;
            margin: 0 0 10px 0;
        }
    }
</style>